import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useFastApi } from 'fastApi'
import { Stream } from '@cloudflare/stream-react'
import { Spinner } from 'lp-components'
import { noop } from 'lodash'
import { isTokenExpired } from 'utils'

const yellowBase = '#FDDC2F'

const propTypes = {
	authToken: PropTypes.string,
	imageUrl: PropTypes.string,
	isDisabled: PropTypes.bool,
	isPrivate: PropTypes.bool,
	setErrorType: PropTypes.func.isRequired,
	src: PropTypes.string.isRequired,
}

const VideoPlayer = ({
	authToken = null,
	imageUrl = '',
	isDisabled = false,
	isPrivate = false,
	setErrorType,
	src,
}) => {
	const [signedToken, setSignedToken] = useState(null)
	const [isVideoReady, setIsVideoReady] = useState(false)

	const api = useFastApi(authToken)

	useEffect(() => {
		if (!isPrivate) return

		const fetchEncryptedUID = async () => {
			try {
				const {
					result: { token },
				} = await api.get('/cloudflare/stream/token', {
					query: { video_uid: src },
				})
				setSignedToken(token)
			} catch {
				setErrorType('error')
			}
		}

		fetchEncryptedUID()
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isPrivate, src])

	const handleTokenValidation = () => {
		if (isTokenExpired(signedToken)) {
			setErrorType('expired')
		}
	}

	if (isPrivate && !signedToken) {
		return (
			<div className="video-player-container">
				<div className="is-loading">
					<Spinner />
				</div>
			</div>
		)
	}

	return (
		<div className="video-player-container">
			<Stream
				autoplay={!(isPrivate && isDisabled)}
				controls={!(isPrivate && isDisabled)}
				src={signedToken ?? src}
				poster={imageUrl}
				primaryColor={yellowBase}
				onPlay={isPrivate ? handleTokenValidation : noop}
				onCanPlay={() => setIsVideoReady(true)}
				onError={() => setErrorType('error')}
			/>
			{!isVideoReady && <div className="is-loading" />}
		</div>
	)
}

VideoPlayer.propTypes = propTypes

export default VideoPlayer
